import { TextButton } from "../../../components/1elements"

const HMapButton = ({
  children,
  className,
  text,
  onClick,
  secondaryButton,
  disabled
}) => {
  const buttonProps = {
    ...(className && { className }),
    ...(disabled && { disabled }),
    ...(onClick && { clickHandler: onClick }),
    ...(secondaryButton && { secondaryButton: !!secondaryButton })
  }

  return <TextButton {...buttonProps}>{children || text}</TextButton>
}

export default HMapButton
